import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { AddToCart } from '@grandvisionhq/carts-v2';
import { useIntl } from '@grandvisionhq/state';
import { useGetPriceSegment } from '../../../hooks/use-get-price-segment.js';

var NonRxProductAddToCartButton = (_param)=>{
    var { activeSku , offeringSku , bundleLineItemSkus , onSuccess , quantity =1 , caption  } = _param, tealiumProps = swcHelpers.objectWithoutProperties(_param, [
        "activeSku",
        "offeringSku",
        "bundleLineItemSkus",
        "onSuccess",
        "quantity",
        "caption"
    ]);
    const { getLabel  } = useIntl();
    const { priceSegment  } = useGetPriceSegment();
    let lineItemDraft;
    if (!bundleLineItemSkus || bundleLineItemSkus.length === 0) {
        // Add a Regular product to cart
        const draft = {
            sku: activeSku,
            quantity,
            type: 'regular'
        };
        if (priceSegment) {
            draft.typeDetails = {
                segments: [
                    {
                        channelKey: priceSegment
                    }
                ]
            };
        }
        lineItemDraft = draft;
    } else {
        // Add a Non-Rx Bundle product to cart
        const skus = offeringSku ? [
            offeringSku,
            ...bundleLineItemSkus
        ] : bundleLineItemSkus;
        const draft = {
            sku: activeSku,
            quantity: 1,
            type: 'non-prescription-bundle',
            bundleLineItems: skus.map((sku)=>({
                    sku,
                    quantity: 1
                })
            )
        };
        if (priceSegment) {
            draft.typeDetails = {
                segments: [
                    {
                        channelKey: priceSegment
                    }
                ]
            };
        }
        lineItemDraft = draft;
    }
    return /*#__PURE__*/ React.createElement(AddToCart, swcHelpers.extends({
        caption: caption !== null && caption !== void 0 ? caption : getLabel('products.actions.addToCart'),
        onSuccess: onSuccess,
        lineItemDrafts: [
            lineItemDraft
        ]
    }, tealiumProps));
};

export { NonRxProductAddToCartButton };
//# sourceMappingURL=NonRxProductAddToCartButton.js.map
